import React from "react";
import containerUtils, { resolveChildren } from "../../utils/containerUtils";

export const Container = (props) => {
    const containerProps = containerUtils.extractComponentProps(props, {
        additionalProps: [
            "tag", //html tagName
            "extraClasses",
            "style" //React supported style object
        ]
    });
    if (!containerProps.tag && (containerProps.extraClasses || containerProps.style)) {
        containerProps.tag = "div";
    }
    if (containerProps.tag) {
        let propsToPass = {
            className: containerProps.extraClasses || "",
            style: containerProps.style
        };
        let tag = containerProps.tag;
        let children = resolveChildren(props);
        return React.createElement(tag, propsToPass, children);
    } else {
        return resolveChildren(props);
    }
};

Container.displayName = "Container"; //minification concern

export default Container;
